require('match-media');

const MOBILE = 'mobile';
const TABLET = 'tablet';
const DESKTOP = 'desktop';
const MOBILE_QUERY = '(max-width: 667px)';
const TABLET_QUERY = '(min-width: 668px) and (max-width: 1023px)';
const DESKTOP_QUERY = '(min-width: 1024px)';

const deviceIs = type => {
    let result = false;

    switch (type) {
        case MOBILE:
            result = matchMedia(MOBILE_QUERY).matches;
            break;

        case TABLET:
            result = matchMedia(TABLET_QUERY).matches;
            break;

        case DESKTOP:
            result = matchMedia(DESKTOP_QUERY).matches;
            break;
    }

    return result;
};

const isMobile = () => deviceIs(MOBILE);

const isTablet = () => deviceIs(TABLET);

const isDesktop = () => deviceIs(DESKTOP);

const getDeviceType = () => {
    if(isMobile()) {
        return MOBILE;
    }

    if(isTablet()) {
        return TABLET;
    }

    return DESKTOP;
};

module.exports = {
    DESKTOP,
    DESKTOP_QUERY,
    deviceIs,
    getDeviceType,
    isDesktop,
    isMobile,
    isTablet,
    MOBILE,
    MOBILE_QUERY,
    TABLET,
    TABLET_QUERY
};
